module.exports = __webpack_public_path__ + "img/img-1.28cc3e5f.jpg";